import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Person from "../img/1.jpg";

export default function PaperSheet() {
	const [open, setOpen] = React.useState(false);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	return (
		<div>
			<div className="w-75 mx-auto profile">
				<div class="demo-card-wide mdl-card mdl-shadow--2dp w-100">
					<div class="mdl-card__title"></div>
					<div className="avatar-wrapper">
						<div className="avatar">
							<img src={Person} alt="profile" />
						</div>
					</div>
					<div class="mdl-card__supporting-text w-100 text-center">
						<h4 style={{ fontWeight: 600, marginBottom: 0 }}>Test Name</h4>
						<h6 style={{ marginTop: 0, fontSize: 13 }}>Assistant Professor</h6>
						<p>Daffodil International University</p>
					</div>
					<div class="mdl-card__menu">
						<button
							class="mdl-button mdl-button--icon mdl-js-button mdl-js-ripple-effect"
							onClick={handleClickOpen}
						>
							<i class="material-icons">edit</i>
						</button>
					</div>
				</div>
			</div>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="form-dialog-title"
			>
				<DialogTitle id="form-dialog-title">Edit Profile</DialogTitle>
				<DialogContent>
					<TextField
						autoFocus
						margin="dense"
						id="name"
						label="Full Name"
						type="text"
						value="Shahriar Chowdhury"
						fullWidth
					/>
					<TextField
						autoFocus
						margin="dense"
						id="name"
						label="Designation"
						type="text"
						value="Assistant Professor"
						fullWidth
					/>
					<TextField
						autoFocus
						margin="dense"
						id="name"
						label="Email Address"
						type="email"
						value="mail@diu.edu.bd"
						fullWidth
					/>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="primary">
						Cancel
					</Button>
					<Button onClick={handleClose} color="primary">
						Save Changes
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
}
